module.exports = __webpack_public_path__ + "img/smarties.8e7afd4c.jpg";